/**
 * The onboarding steps, shared by the flow itself and the blueprint screen that
 * closes it — the blueprint shows the same rail with every step behind it, so
 * finishing does not drop the member out of the layout they just walked.
 */
export const ONBOARDING_STEPS = [
  'profile',
  'focus',
  'goal',
  'assessment',
  'ritual',
  'style',
] as const;
export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

export const ONBOARDING_STEP_LABELS = [
  'About you',
  'Your focus',
  'Your goal',
  'Where you are starting',
  'Your routine',
  'Coaching style',
] as const;
